<template>
  <span>{{ value }}</span>
</template>

<script setup>
/* global defineProps */
import { computed } from 'vue'
import { formatCurrencyPrice } from '@/widgets/booking/utils/currency'

const props = defineProps({
  price: {
    type: [Object, Number],
    default: () => ({ value: 0, currency: 'RUB' })
  },
  digits: {
    type: Number,
    default: 0
  }
})

const value = computed(() => formatCurrencyPrice(props.price, props.price?.currency, {
  minimumFractionDigits: props.digits,
  maximumFractionDigits: props.digits
}))
</script>
